import { GET } from "../../lib/core/api"
import { createAsyncAction } from "../../lib/core/redux.utils"

export const getSubjects = createAsyncAction("GET_SUBJECTS", () =>
  GET("/subjects/"),
)
